import React, { useEffect, useState } from "react";
import protfolio1 from "../../Assets/protfolios/protfolio1.png";
import protfolio2 from "../../Assets/protfolios/protfolio2.png";
import protfolio3 from "../../Assets/protfolios/protfolio3.png";
import protfolio4 from "../../Assets/protfolios/protfolio4.png";
import protfolio5 from "../../Assets/protfolios/protfolio5.png";
import protfolio6 from "../../Assets/protfolios/protfolio6.png";

const Protfolios = () => {
  const [protfolios, setProtfolios] = useState([]);
  useEffect(() => {
    fetch("protfolio.json")
      .then((res) => res.json())
      .then((data) => setProtfolios(data));
  }, []);

  const openInNewTab = (url) => {
    const newWindow = window.open(url, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  };

 

  return (
    <div className="bg-accent md:pl-4 py-5">
      <div className="pt-20 mb-8">
        <h2 className="text-4xl font-bold uppercase text-white border-l-4 border-primary pl-3">
          PROTFOLIOS
        </h2>
        <span class="text-6xl font-semibold hover:font-bold uppercase text-base-100">
          PROTFOLIOS
        </span>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        {protfolios.map((protfolio) => (
          <div class="card card-compact md:w-96 bg-base-100 shadow-xl">
            <figure>
              <img className="w-100" src={protfolio.image} alt="Shoes" />
            </figure>
            <div class="card-body">
              <h2 class="card-title">{protfolio.title}</h2>
              <p>{protfolio.description}</p>
              <div className="flex justify-around">
                <button
                  onClick={() => openInNewTab(protfolio.live)}
                  class="btn btn-outline btn-info"
                >
                  Live Site
                </button>

                <button
                  onClick={() => openInNewTab(protfolio.client)}
                  class="btn btn-outline btn-info"
                >
                  Client Site
                </button>
             
                  <button
                  onClick={() => openInNewTab(protfolio.server)}
                  class="btn btn-outline btn-info"
                >
                  Server Site
                </button>
                  
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Protfolios;
